import { NORMAL, PERSONNALISE, REGROUPEMENT } from '@/configuration/devisConf';
import { addReferenceEcheancierToLigneCommande }
  from '@/services/commande/echeancierFacturation/addReferenceEcheancierToLigneCommande';
import fusionEcheancier from '@/services/commande/echeancierFacturation/fusionEcheancier';

function getReferencesEcheancierWithReferencePerso(lignes, referencePerso) {
  let referencesEcheancier = [];
  lignes.forEach((ligne) => {
    if (ligne.type === NORMAL && ligne.referencePersonnalise === referencePerso) {
      referencesEcheancier.push(ligne.referenceEcheancier);
    } else if (ligne.type === REGROUPEMENT && ligne.referencePersonnalise === referencePerso) {
      referencesEcheancier = referencesEcheancier.concat(
        ligne.lignesCommande
          .filter((ligneEnfant) => { return ligneEnfant.type === NORMAL; })
          .map((ligneEnfant) => { return ligneEnfant.referenceEcheancier; }),
      );
    }
  });
  return referencesEcheancier;
}

function updateReferenceEcheancierForReferencePerso(commande, idsReferencePerso) {
  idsReferencePerso.forEach((idReferencePerso) => {
    const referencecsEcheancier = getReferencesEcheancierWithReferencePerso(
      commande.lignesCommande, idReferencePerso,
    );
    fusionEcheancier(referencecsEcheancier, commande);
  });
}

export default function addReferenceEcheancierToAllLignes(commande) {
  const idsReferencePerso = [];
  commande.lignesCommande.forEach((ligne) => {
    if (ligne.type === NORMAL && !ligne.referenceEcheancier) {
      addReferenceEcheancierToLigneCommande(ligne, commande);
    }
    if (ligne.type === REGROUPEMENT) {
      ligne.lignesCommande.forEach((ligneEnfant) => {
        if (ligneEnfant.type === NORMAL && !ligne.referenceEcheancier) {
          ligneEnfant.dateDebut = ligneEnfant.dateDebut ?? ligne.dateDebut;
          ligneEnfant.dateFin = ligneEnfant.dateFin ?? ligne.dateFin;
          addReferenceEcheancierToLigneCommande(ligneEnfant, commande);
        }
      });
    }
    if (ligne.type === PERSONNALISE) idsReferencePerso.push(ligne.referencePersonnalise);
  });
  updateReferenceEcheancierForReferencePerso(commande, idsReferencePerso);
}
